<template lang="html">
  <div class="">
    <h3>Gestione Conti</h3>
    <br>
    <Select v-model="filters.trashed">
      <Option :value="0"><Icon type="ios-person"/> Attivi</Option>
      <Option :value="1"><Icon type="ios-trash"/> Nascosti</Option>
    </Select>
    &nbsp;
    <Select v-model="filters.type">
      <Option :value="0">Tutti</Option>
      <Option v-for="t in types" :key="t.type" :value="t.type">{{ t.label }}</Option>
    </Select>
    &nbsp;
    <Input v-model="filters.search" placeholder="Ricerca..."/>
    &nbsp;

    <Button
    @click="ledger={company_id:$store.company.id, is_custom: true}; show_ledger_form=true"
    type="primary"
    style="float: right">
      <Icon type="plus-round"/>
      Nuovo conto
    </Button>
    <Button
    @click="ledger={company_id:$store.company.id, is_custom: true, is_bank: true, type: 'pa', category: 'Attivo Circolante', code: nextBankCode()}; show_ledger_form=true"
    type="primary"
    style="float: right; margin: 0 5px;">
      <Icon type="plus-round"/>
      Nuova banca
    </Button>



    <div class="ivu-table ivu-table-stripe spaced" style="margin: 1em 0">
      <table class="ivu-table-body">
        <thead>
          <tr>
            <th style="width: 80px">Codice</th>
            <th>Nome</th>
            <th>Tipo</th>
            <th>Categoria</th>
            <th>Descrizione</th>
            <th style="width: 200px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!ledgers.length">
            <td colspan=6>
              Nessun conto trovato
            </td>
          </tr>
          <tr v-for="t in ledgers" :key="t.id">
            <td>{{ t.code }}</td>
            <td>{{ t.name }}</td>
            <td>
              <span v-if="types">
                {{ types.find(q => q.type == t.type).label }}
              </span>
              <span v-else>
                <Spin/>
              </span>
            </td>
            <td>{{ t.category }}</td>
            <td>{{ t.description }}</td>
            <td style="text-align: right">
              <ButtonGroup>
                <Button type="primary" shape="circle" @click="ledger=t; show_ledger_form=true">
                  <Icon type="edit"/>
                </Button>
                <Button type="info" shape="circle" @click="partitario = {ledger:t, page: 0}">
                  Partitario
                </Button>
                <Button v-if="!t.is_hidden" type="error" shape="circle" @click="confirm('Sicuri?') && $http['delete']('ledgers/'+t.id).then(refreshLedgers)">
                  <Icon type="ios-trash"/>
                </Button>
                <Button v-else type="success" shape="circle" @click="confirm('Sicuri?') && $http['delete']('ledgers/'+t.id).then(refreshLedgers)">
                  Riabilita
                </Button>
              </ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
      <Spin size="large" fix v-if="loading"/>
    </div>


    <Modal v-model="show_ledger_form" class-name="no-foot">
      <LedgerForm v-if="show_ledger_form" @close="show_ledger_form=false" :edit="ledger" :types="types"/>
    </Modal>

    <Modal :value="!!partitario" @input="!$event && (partitario = null)" class-name="no-foot very-large">
      <div v-if="partitario" style="">
        <h1>[{{ partitario.ledger.code }}] {{ partitario.ledger.name }}</h1>
        <br>
        <h2>Anno e mese di attività:</h2>
        <Select v-model="partitario.year">
          <Option v-for="y in contab_years" :key="y" :value="y">{{ y }}</Option>
        </Select>
        <Select v-model="partitario.month">
          <Option v-for="(m, m_i) in [0, 1,2,3,4,5,6,7,8,9,10,11, 12]" :key="m_i" :value="m">{{ !m ? 'Tutti' : $d(Date.maintain(`2018-${m}-01`), 'justmonth') }}</Option>
        </Select>

        <br>
        <br>
        <div v-if="partitario.loading || !partitario.data">
          <i>Caricamento...</i>
        </div>
        <div v-else>

          <Button type="primary" @click.native="print_loading = true; $utils.download(`partitario-${partitario.ledger.code}-${partitario.year}.pdf`, 'transactions', Object.assign({_print_partitario:1}, partitario_params), () => {print_loading = false})" :loading="print_loading">
            Stampa partitario
          </Button>

          <div class="ivu-table spaced" style="margin: 1em 0;;">

            <Page v-if="filtered_partitario.length > part_page"
            style="margin: 1em 0"
            :current="partitario.page+1"
            :total="filtered_partitario.length"
            :page-size="part_page"
            @on-change="partitario.page = $event-1"/>

            <div v-if="!filtered_partitario.length">
              Nessun movimento nel periodo selezionato
            </div>
            <table v-else>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Data</th>
                  <th>Categoria</th>
                  <th style="width: 250px">Descrizione</th>
                  <th>Conti</th>
                  <th class="text-right">Dare</th>
                  <th class="text-right">Avere</th>
                  <th class="text-right">Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th colspan="2" style="text-align: right">
                    <b>Saldi inizio periodo selezionato:</b>
                  </th>
                  <th class="text-success text-right">
                    <span>{{ $n((filtered_partitario[0].prev || {}).tot_dare || 0, 'currency') }}</span>
                  </th>
                  <th class="text-error text-right">
                    <span>{{ $n((filtered_partitario[0].prev || {}).tot_avere || 0, 'currency') }}</span>
                  </th>
                  <th class="text-info text-right">
                    <span>{{ $n((filtered_partitario[0].prev || {}).tot_all || 0, 'currency') }}</span>
                  </th>
                </tr>
                <tr v-for="(tx, tx_i) in filtered_partitario" v-if="Math.floor(tx_i/part_page) == partitario.page">
                  <td>
                    {{ tx.proto }}
                  </td>
                  <td>
                    {{ $d(Date.maintain(tx.date)) }}
                  </td>
                  <td>
                    {{ tx.category }}
                  </td>
                  <td>
                    {{ (tx.invoice || {}).contact_name }}
                    {{ tx.causal }}
                  </td>
                  <td>
                    <template v-for="line in tx.lines">
                      <Tooltip :content="line.ledger.name + ': ' + $n(line.amount, 'currency')" placement="top">
                        <Tag :color="line.amount > 0 ? 'blue' : 'red'" type="border" class="wollotag">{{ line.ledger.code }}</Tag>
                      </Tooltip>
                    </template>
                  </td>
                  <td class="text-success text-right">
                    <span v-if="tx.led_dare">{{ $n(tx.led_dare, 'currency') }}</span>
                    <span v-else>--</span>
                  </td>
                  <td class="text-error text-right">
                    <span v-if="tx.led_avere">{{ $n(tx.led_avere, 'currency') }}</span>
                    <span v-else>--</span>
                  </td>
                  <td class="text-info text-right">
                    <span>{{ $n(tx.tot_all, 'currency') }}</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th colspan="2" style="text-align: right">
                    <b>Saldi fine periodo selezionato:</b>
                  </th>
                  <th class="text-success text-right">
                    <span>{{ $n(filtered_partitario[filtered_partitario.length-1].tot_dare, 'currency') }}</span>
                  </th>
                  <th class="text-error text-right">
                    <span>{{ $n(filtered_partitario[filtered_partitario.length-1].tot_avere, 'currency') }}</span>
                  </th>
                  <th class="text-info text-right">
                    <span>{{ $n(filtered_partitario[filtered_partitario.length-1].tot_all, 'currency') }}</span>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>
    </Modal>
  </div>
</template>

<script>
import LedgerForm from './ledger-form'
export default {
  components: {
    LedgerForm,
  },

  data() {
    return {
      loading: true,
      ledgers: [],
      filters: {
        company_id: this.$store.company.id,
        trashed: 0,
        type: 0,

      },
      ledger: null,
      types: null,
      show_ledger_form: false,
      partitario: null,
      contab_years: [],
      print_loading: false,
      part_page: 200,
    }
  },

  mounted() {
    this.refreshLedgers()
    this.$root.$on('ledgers', this.refreshLedgers)

    this.$http.get('ledger-types?company_id='+this.$store.company.id).then(res => {
      this.types = res.data
    })

    this.$http.get('contab-years?company_id=' + this.$store.company.id).then(res => {
      this.contab_years = res.data.map(y => parseInt(y))
    })
  },
  beforeDestroy() {
    this.$root.$off('ledgers', this.refreshLedgers)
  },

  computed: {
    partitario_params () {
      var p = this.partitario
      if (!p) return

      var params = {
        per_page: 999999,
        ledger_id: p.ledger.id,
        company_id: this.$store.company.id,
      }

      params.year = p.year
      if (p.month) {
        params.partitario_month = p.month
      }
      // } else {
      //   params.month = p.year+'-'+(p.month < 10 ? `0${p.month}` : p.month)
      // }

      return params
    },

    filtered_partitario () {
      let p = this.partitario
      if (!p.month) return p.data
      return p.data.filter(tx => parseInt(tx.date.split('-')[1]) == (p.month))
    }
  },

  methods: {
    refreshLedgers(page) {
      console.log('refresh ledgers')
      var params = Object.assign({
      }, this.filters)
      this.loading = true
      this.$http.get('ledgers', {params}).then(res => {
        this.ledgers = res.data
      }).finally(res => {
        this.loading = false
      })
    },

    nextBankCode() {
      var id = ((this.ledgers||[]).reduce((a, b) => {
        var m = b.code.match(/^B(\d+)$/)
        return Math.max(a, m ? 1*m[1] : 0)
      }, 0) + 1)
      if (id < 10) id = '0'+id
      return 'B'+id
    },

    confirm(msg) {
      return confirm(msg)
    },

    refreshPartitario() {
      console.log('refresh partitario')

      var p = this.partitario
      if (!p) return
      let params = this.partitario_params

      this.$set(p, 'loading', true)
      this.$http.get('transactions', {params}).then(res => {
        var txs = res.data.data.reverse()
        txs.forEach((tx, tx_i) => {
          tx.leds = tx.lines.filter(l => l.ledger_id == p.ledger.id)
          tx.prev = txs[tx_i-1]
          tx.tot_all = this._.sum(tx.leds.map(l => l.amount))
          tx.tot_dare = this._.sum(tx.leds.filter(l => l.amount > 0).map(l => l.amount))
          tx.tot_avere = this._.sum(tx.leds.filter(l => l.amount < 0).map(l => -l.amount))

          tx.led_all = tx.tot_all
          tx.led_dare = tx.tot_dare
          tx.led_avere = tx.tot_avere

          if (tx.prev) {
            tx.tot_all+= tx.prev.tot_all
            tx.tot_dare+= tx.prev.tot_dare
            tx.tot_avere+= tx.prev.tot_avere
          }
        })
        this.$set(p, 'data', txs)
        this.$set(p, 'loading', false)
      })
    },
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshLedgers()
      }, 300)
    },

    'partitario' (p) {
      if (p) {
        this.$set(p, 'year', this._.max(this.contab_years))
        this.$set(p, 'month', (new Date).getMonth()+1)
      }
      this.refreshPartitario()
    },

    'partitario.year' (year) {
      this.refreshPartitario()
    },
    'partitario.month' (year) {
      if (this.partitario) this.partitario.page = 0
      // this.refreshPartitario()
    },
  }
}
</script>

<style lang="css">
</style>
